import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { FileDown, FileSpreadsheet, FileText } from "lucide-react";
import { exportToPDF, exportToExcel } from "@/lib/exports";

export default function ExportButton({ title, columns, rows, filename = "reporte" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2" data-testid="export-btn">
          <FileDown size={14} /> Exportar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => exportToPDF({ title, columns, rows, filename: `${filename}.pdf` })} data-testid="export-pdf">
          <FileText size={14} className="mr-2 text-[#b53a25]" /> PDF
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => exportToExcel({ columns, rows, filename: `${filename}.xlsx` })} data-testid="export-excel">
          <FileSpreadsheet size={14} className="mr-2 text-[#2b8a5b]" /> Excel
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
